import { Component, OnInit, Input, Output, forwardRef, EventEmitter } from '@angular/core';
import { FormBuilder, UntypedFormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ControlValueAccessor, Validators } from '@angular/forms';



@Component({
  selector: 'app-nametext-input',
  templateUrl: './nametext-input.component.html',
  styleUrls: ['./nametext-input.component.scss'],
  providers: [
    {
      provide: NG_VALIDATORS, useExisting: NameTextInputComponent, multi: true
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NameTextInputComponent),
      multi: true
    }]
})
export class NameTextInputComponent implements OnInit {
  onTouched: () => void;
  onChange = (value: string) => { }; 

  @Input() controllerData;
  @Input() parent: UntypedFormGroup;
  @Input() pageName:string;
  @Input() controlName:string;
  public textValue: string;
  

  @Output() textChangeEventEmitter: EventEmitter<string> = new EventEmitter<string>();
  /**
   * This is a constructor
   */
  constructor() {
  
  }

  ngOnInit() {

    if(this.parent.get([this.controlName])){
      this.textValue = this.parent.get([this.controlName]).value;
    }
    else{
      this.textValue = "";
    }
   
    //this.setMiddleNameValidators();

  }
  writeValue(value: any): void {
    this.controllerData['value'] = value ? value: '';
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  inputTextChangeHandler(val){
    this.textChangeEventEmitter.emit(val);
  }

  validate() {
    // tslint:disable-next-line: max-line-length
    const nameValidation: RegExp = /^(?=.{1,35}$)[a-zA-Z]+(?:[- '][a-zA-Z]+)*$/;
    const forbidden = nameValidation.test(this.parent.get(this.controlName).value);
   

    if (this.parent.get(this.controlName).value) {
      return forbidden ? null : { notValidname: true};
      // tslint:disable-next-line:align
      } return null;
  }
  /* validateInput = () => {
    this.onChangeHandler.emit();
  } */

 

}
